import React from 'react'
import styled from 'styled-components'
import RSClipSpinner from 'react-spinners/ClipLoader'
import { STYLES } from '../../static/style'

const StyledSpinner = styled(RSClipSpinner).attrs({
  color: STYLES.TEXT_COLOR,
})``

interface IClipSpinnerProps {
  margin?: string
  className?: string
  size?: number
}

const ClipSpinner: React.FC<IClipSpinnerProps> = ({
  margin = '0',
  size = 16,
  className,
}) => (
  <StyledSpinner size={size} className={className} margin={margin}>
    <ClipSpinner size={size} />
  </StyledSpinner>
)

export { ClipSpinner }
